module.exports = __webpack_public_path__ + "img/master-card.c6550c82.png";